<template>
  <div class="w-3/4">
    <router-link
      to="/"
    >
      <img src='@/assets/HeffronLogo_RGB.svg' alt="Heffron" width="w-full" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'heffron-logo',
};
</script>

<style>

</style>
